import { HostService } from '../host/host.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FamilyService {
  host:string;
  
  constructor(
    private hostService:HostService,
    private http:HttpClient
  ) {
    this.host=this.hostService.host;
  }
  
  getFamiliesOfCarte(){
    return this.http.get(this.hostService.host+'families/cmd/carte');
  }

  getMenuCategoriesOfCarte(){
    return this.http.get(this.hostService.host+'menucategories/cmd/carte');
  }
  
}
